
<mat-form-field class="example-full-width" floatLabel="never">

  <input #textBox matInput autocomplete="off" type="text" [attr.width]="activity.controlWidth" [attr.min]="activity.minValue" [attr.max]="activity.maxValue"
      [attr.maxlength]="activity.maxLength" name="ans" [(ngModel)]="activity.ans" [formControl]="activityControl"
      [required]="activity.isRequired" [placeholder]="activity.hint" [matTooltip]="activity.ans" matTooltipPosition="below"/>

  <mat-error class="m-top-8" *ngIf="activityControl.hasError('required')">
      {{'Required' | translate}}*
  </mat-error>

</mat-form-field>
